import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { getPropertyDefinition, getPropertyValueFromProperties } from '../../../helpers/propertiesHelpers';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const INTEGRATION_PROCESSOR_TYPES = new Set(['quickbooks', 'xero']);
const CommercePaymentSecondaryPostfixContent = ({
  objectId,
  properties,
  propertyDefinitions
}) => {
  var _getPropertyValueFrom;
  const processorType = (_getPropertyValueFrom = getPropertyValueFromProperties(properties, 'hs_processor_type')) !== null && _getPropertyValueFrom !== void 0 ? _getPropertyValueFrom : '';
  const propertyDefinition = getPropertyDefinition('hs_processor_type', propertyDefinitions);

  // We only render the processor type for payments synced from one of our integrations, e.g. QuickBooks or Xero
  if (!!propertyDefinition && INTEGRATION_PROCESSOR_TYPES.has(processorType)) {
    return /*#__PURE__*/_jsx(Text, {
      marginBlockStart: "300",
      textAlign: "right",
      children: /*#__PURE__*/_jsx(FormattedPropertyV2, {
        objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
        objectId: `${objectId}`,
        value: processorType,
        getDraftValue: () => undefined,
        getSavedValue: propertyName => getPropertyValueFromProperties(properties, propertyName)
        // @ts-expect-error Known property issue as they have not updated the type definitions
        // https://hubspot.slack.com/archives/C025K57CMMG/p1696524684019289?thread_ts=1696349045.450059&cid=C025K57CMMG
        ,
        property: propertyDefinition
      })
    });
  }
  return null;
};
export default CommercePaymentSecondaryPostfixContent;